import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  msisdn: "",
};
// Megaquize msisidn
const msisdnSlice = createSlice({
  name: "msisdn",
  initialState,
  reducers: {
    setMsisdn: (state, action) => {
      state.msisdn = action.payload;
    },
    clearMsisdn: (state) => {
      state.msisdn = "";
    },
  },
});

export const { setMsisdn, clearMsisdn } = msisdnSlice.actions;
export default msisdnSlice.reducer;